import { ManuallyConfirmationStatusType } from "../../enums/index";
function getManuallyConfirmationStatusClass(type) {
  let result = "";
  switch (type) {
    case ManuallyConfirmationStatusType.None():
      result = "";
      break;
    case ManuallyConfirmationStatusType.NoNeed():
      result = "suspend";
      break;
    case ManuallyConfirmationStatusType.ReadyToAccept():
      result = "";
      break;
    case ManuallyConfirmationStatusType.Accepted():
      result = "enabled";
      break;
    default:
      result = "";
      break;
  }
  return result;
}
export default getManuallyConfirmationStatusClass;
